import React from 'react'
import {
  Card,
  Form,
  Button,
  Modal,
  Space,
  Table,
  Drawer,
  ConfigProvider,
  Breadcrumb,
  Input,
  TreeSelect,
  Select,
  Badge,
  Tooltip,
  message,
  Transfer,
} from 'antd'
import styles from './index.module.scss'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import zhCH from 'antd/lib/locale/zh_CN'
import {
  addUser,
  batchDel,
  changeUserStatus,
  delUsers,
  editUser,
  getTrigger,
  getUserInfo,
  getUserList,
  getUserStatus,
  resetChangeFn,
  resetPassword,
} from '../../../../store/actions/user'
import { getOrgTreeList } from '../../../../store/actions/org'
import { getPermissionLists } from '../../../../store/actions/permission'
import { useRef } from 'react'
import {
  getCompListForNameCode,
  getCompLists,
} from '../../../../store/actions/comp'
import {
  getCompany,
  getDeploy,
  getOaOrg,
  getSuperGroup,
} from '../../../../utils/cookie'
import { useGetState, useSize } from 'ahooks'
import MyButton from '../../../../components/MyButton'
import { MyIcon } from '../../../../routers'
export default function Article() {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [watchUser, setWatchUser] = useState(false)
  const [user, setUser] = useState({})
  const userForm = useRef()
  const [userInfos, setUserInfos, getUserInfos] = useGetState({})
  const [delModal, SetDelModal] = useState(false)
  const [orgId, setOrgId] = useState('')
  const [chargeOrgId, setChargeOrgId] = useState('')
  const [orgIds, setOrgIds] = useState('')
  const [batchAdd, SetBatchAdd] = useState('')
  const [compId, setCompId, getCompId] = useGetState(getCompany())
  const [resetModal, setResetModal] = useState(false)
  const [resetChangeModal, setResetChangeModal] = useState(false)
  const [resetLoginVisible, setResetLoginVisible] = useState(false)

  const [orgData, setOrgData] = useState([])
  const [userCoId, setUserCoId] = useState('')
  // 穿梭框
  const [targetKeys, setTargetKeys] = useState([])
  const [batchUserDel, setBatchUserDel] = useState(false)
  const tableRef = useRef(null)
  const size = useSize(tableRef)
  const {
    total,
    userList,
    userInfo: userInfoItem,
  } = useSelector((state) => state.user)
  const userInfo = useSelector((state) => state.login.userInfo)
  const rulesObj = useRef({
    co_id: [
      {
        required: true,
        message: '请选择企业/产品',
      },
    ],
    username: [
      {
        required: true,
        message: '用户名不能为空',
      },
      {
        pattern: /^[a-zA-Z][a-zA-Z0-9-_]{3,19}$/,
        message: '4~20个字符，数字、字母、中划线或下划线组合',
      },
      {
        validator(_, value) {
          return dispatch(
            getTrigger(
              {
                pk: getUserInfos().user ? getUserInfos().user.id : null,
                // co_id: getCompId() ? getCompId() : getUserInfos().co_id,
                field: 'name',
                value,
              },
              false
            )
          ).then(({ data }) => {
            if (!data.data) {
              return Promise.resolve()
            }
            return Promise.reject(new Error('用户名已存在'))
          })
        },
        validateTrigger: ['onBlur'],
      },
    ],
    email: [
      {
        pattern:
          /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
        message: '邮箱地址不合法',
      },
    ],
    mobile_no: [
      {
        pattern:
          /^(13\d|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18\d|19[0-35-9])\d{8}$/,
        message: '手机号格式不对',
      },
    ],
    full_name: [
      {
        pattern: /^[^\s]+(\s+[^\s]+)*/,
        message: '不能以空格开头',
      },
    ],
    nickname: [
      {
        pattern: /^[^\s]+(\s+[^\s]+)*/,
        message: '不能以空格开头',
      },
    ],
    employee_no: [
      {
        required: getOaOrg() === 'true' ? true : false,
        message: '工号不能为空',
      },
    ],
  })

  const [selectedRowKey, setSelectedRowKey] = useState(null)
  const getRowClassName = (record) => {
    return record.co_user_id === selectedRowKey ? 'selected-row' : ''
  }

  const handleChange = (targetKeys) => {
    SetBatchAdd(targetKeys)
    setTargetKeys(targetKeys)
  }

  const resetCharge = (user) => {
    setUserInfos(user)
    setResetChangeModal(true)
  }

  const resetChange = async (info) => {
    const values = {
      co_user_id: info.co_user_id,
      co_id: info.co_id,
    }
    const res = await dispatch(resetChangeFn(values, false))
    if (res.data.code === 0) {
      message.success('同步成功')
    } else {
      message.error('同步失败')
    }
    paramsRef.current.page = 1
    await dispatch(getUserList(userParamsRef.current))
    setResetChangeModal(false)
  }

  useEffect(() => {
    dispatch(
      getUserStatus({ co_id: getCompany(), dic_code: 'SYS_CO_USER_STATUS' })
    )
    userInfo?.co_type_code === 'ADMIN_GROUP' &&
      dispatch(getCompListForNameCode())
  }, [userInfo])

  const { orgTreeListCope } = useSelector((state) => state.org)

  const { compListForNameCode } = useSelector((state) => state.comp)
  const { statusList } = useSelector((state) => state.user)
  const { permissionListAll } = useSelector((state) => state.permission)

  const paramsRef = useRef({
    page: 1,
    page_size: 10,
  })
  useEffect(() => {
    paramsRef.current.page = 1
    paramsRef.current.page_size = 10
  }, [])
  const columns =
    userInfo?.co_type_code === 'ADMIN_GROUP'
      ? [
          {
            title: '序号',
            dataIndex: 'index',
            width: 80,
            render(text, record, index) {
              return (
                <span>
                  {(paramsRef.current.page - 1) * paramsRef.current.page_size +
                    index +
                    1}
                </span>
              )
            },
          },
          {
            title: '企业/产品',
            dataIndex: 'user',
            width: 200,
            ellipsis: {
              showTitle: false,
            },
            render: (text, record, index) => (
              <Tooltip placement="leftTop" title={record.co_name}>
                {record.co_name}
              </Tooltip>
            ),
          },
          {
            title: '用户名',
            dataIndex: 'user',
            width: 180,
            ellipsis: {
              showTitle: false,
            },
            render: (text, record, index) => (
              <Tooltip placement="leftTop" title={text.username}>
                {text.username}
              </Tooltip>
            ),
          },
          {
            title: '手机号',
            dataIndex: 'mobile_no',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text, record, index) => {
              const user = record.user
              return (
                <Tooltip placement="leftTop" title={user.mobile_no}>
                  {user.mobile_no}
                </Tooltip>
              )
            },
          },
          {
            title: '姓名',
            dataIndex: 'full_name',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '昵称',
            dataIndex: 'nickname',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '邮箱',
            dataIndex: 'email',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '工号',
            dataIndex: 'employee_no',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '状态',
            dataIndex: 'status_name',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '是否预置',
            dataIndex: 'is_preset',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render(is_preset) {
              return is_preset ? (
                <div className="is-true">是</div>
              ) : (
                <div className="is-false">否</div>
              )
            },
          },
          {
            title: '归属部门',
            dataIndex: 'orgs',
            width: 180,
            ellipsis: {
              showTitle: false,
            },
            render: (i, text, o) => {
              const t = text.user
              return (
                <Tooltip placement="leftTop" title={t.orgs_name}>
                  {t.orgs_name[0]}
                </Tooltip>
              )
            },
          },
          {
            title: '分管部门',
            dataIndex: 'orgs',
            width: 180,
            ellipsis: {
              showTitle: false,
            },
            render: (i, text, o) => {
              const t = text.user
              return (
                <Tooltip placement="leftTop" title={t.charge_org_name}>
                  {text.charge_manual_flag ? (
                    <span>
                      <span style={{ color: '#fc5061' }}>*</span>
                      {t.charge_org_name}
                    </span>
                  ) : (
                    t.charge_org_name
                  )}
                </Tooltip>
              )
            },
          },
          {
            title: '角色',
            dataIndex: 'roles',
            width: 220,
            ellipsis: {
              showTitle: false,
            },
            render: (i, text, o) => {
              const t = text.user
              const arr = [...t.roles_name, ...t.org_role_names]
              return (
                <Tooltip placement="leftTop" title={arr.join('、')}>
                  {arr.join('、')}
                </Tooltip>
              )
            },
          },
          {
            title: '创建时间',
            dataIndex: 'created_time',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '修改时间',
            dataIndex: 'updated_time',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '操作',
            key: 'user',
            width: 300,
            fixed: 'right',
            render(user) {
              return (
                <Space>
                  <Button
                    type="link"
                    className="edit"
                    onClick={() => {
                      paramsRef.current.page = 1
                      watchUserInfo(user)
                      setUserInfos(user)
                    }}
                  >
                    查看
                  </Button>
                  {getDeploy() !== 'BOX' && (
                    <Button
                      type="link"
                      className="edit"
                      onClick={() => showReset(user)}
                    >
                      重置密码
                    </Button>
                  )}
                  {user.charge_manual_flag && (
                    <Button
                      type="link"
                      className="edit"
                      onClick={() => resetCharge(user)}
                    >
                      恢复同步
                    </Button>
                  )}
                  <Button
                    type="link"
                    className="edit"
                    onClick={() => resetUserLogin(user)}
                  >
                    {user.status_code === 'ENABLE' ? '禁用' : '启用'}
                  </Button>
                  {!user.is_preset && (
                    <>
                      <Button
                        type="link"
                        className="edit"
                        onClick={() => showEdit(user)}
                      >
                        修改
                      </Button>
                      <Button
                        type="link"
                        className="del"
                        onClick={() => showDel(user)}
                      >
                        删除
                      </Button>
                    </>
                  )}
                </Space>
              )
            },
          },
        ]
      : [
          {
            title: '序号',
            dataIndex: 'index',
            width: 80,
            render(text, record, index) {
              return (
                <span>
                  {(paramsRef.current.page - 1) * paramsRef.current.page_size +
                    index +
                    1}
                </span>
              )
            },
          },
          {
            title: '用户名',
            dataIndex: 'user',
            width: 180,
            ellipsis: {
              showTitle: false,
            },
            render: (text, record, index) => (
              <Tooltip placement="leftTop" title={text.username}>
                {text.username}
              </Tooltip>
            ),
          },
          {
            title: '手机号',
            dataIndex: 'mobile_no',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text, record, index) => {
              const user = record.user
              return (
                <Tooltip placement="leftTop" title={user.mobile_no}>
                  {user.mobile_no}
                </Tooltip>
              )
            },
          },
          {
            title: '姓名',
            dataIndex: 'full_name',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '昵称',
            dataIndex: 'nickname',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '邮箱',
            dataIndex: 'email',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '工号',
            dataIndex: 'employee_no',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '状态',
            dataIndex: 'status_name',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '是否预置',
            dataIndex: 'is_preset',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render(is_preset) {
              return is_preset ? (
                <div className="is-true">是</div>
              ) : (
                <div className="is-false">否</div>
              )
            },
          },
          {
            title: '归属部门',
            dataIndex: 'orgs',
            width: 180,
            ellipsis: {
              showTitle: false,
            },
            render: (i, text, o) => {
              const t = text.user
              return (
                <Tooltip placement="leftTop" title={t.orgs_name}>
                  {t.orgs_name[0]}
                </Tooltip>
              )
            },
          },
          {
            title: '分管部门',
            dataIndex: 'orgs',
            width: 180,
            ellipsis: {
              showTitle: false,
            },
            render: (i, text, o) => {
              const t = text.user
              return (
                <Tooltip placement="leftTop" title={t.charge_org_name}>
                  {text.charge_manual_flag ? (
                    <span>
                      <span style={{ color: '#fc5061' }}>*</span>
                      {t.charge_org_name}
                    </span>
                  ) : (
                    t.charge_org_name
                  )}
                </Tooltip>
              )
            },
          },
          {
            title: '角色',
            dataIndex: 'roles',
            width: 220,
            ellipsis: {
              showTitle: false,
            },
            render: (i, text, o) => {
              const t = text.user
              const arr = [...t.roles_name, ...t.org_role_names]
              return (
                <Tooltip placement="leftTop" title={arr.join('、')}>
                  {arr.join('、')}
                </Tooltip>
              )
            },
          },
          {
            title: '创建时间',
            dataIndex: 'created_time',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '修改时间',
            dataIndex: 'updated_time',
            width: 120,
            ellipsis: {
              showTitle: false,
            },
            render: (text) => (
              <Tooltip placement="leftTop" title={text}>
                {text}
              </Tooltip>
            ),
          },
          {
            title: '操作',
            key: 'user',
            width: 220,
            fixed: 'right',
            render(user) {
              return (
                <Space>
                  <Button
                    type="link"
                    className="edit"
                    onClick={() => {
                      paramsRef.current.page = 1
                      watchUserInfo(user)
                      setUserInfos(user)
                    }}
                  >
                    查看
                  </Button>
                  {getDeploy() !== 'BOX' && (
                    <Button
                      type="link"
                      className="edit"
                      onClick={() => showReset(user)}
                    >
                      重置密码
                    </Button>
                  )}
                  {user.charge_manual_flag && (
                    <Button
                      type="link"
                      className="edit"
                      onClick={() => resetCharge(user)}
                    >
                      恢复同步
                    </Button>
                  )}
                  <Button
                    type="link"
                    className="edit"
                    onClick={() => resetUserLogin(user)}
                  >
                    {user.status_code === 'ENABLE' ? '禁用' : '启用'}
                  </Button>
                  {!user.is_preset && (
                    <>
                      <Button
                        type="link"
                        className="edit"
                        onClick={() => showEdit(user)}
                      >
                        修改
                      </Button>
                      <Button
                        type="link"
                        className="del"
                        onClick={() => showDel(user)}
                      >
                        删除
                      </Button>
                    </>
                  )}
                </Space>
              )
            },
          },
        ]

  const watchCol = [
    {
      title: '序号',
      dataIndex: 'index',
      width: '20%',
      render(text, record, index) {
        return <span>{(paramsRef.current.page - 1) * 10 + index + 1}</span>
      },
    },
    {
      title: '角色',
      width: '40%',
      dataIndex: 'name',
      ellipsis: {
        showTitle: false,
      },
      render: (text) => {
        return (
          <Tooltip placement="leftTop" title={text}>
            {text}
          </Tooltip>
        )
      },
    },
    {
      title: '赋权方式',
      width: '40%',
      dataIndex: 'type',
      ellipsis: {
        showTitle: false,
      },
      render: (text) => {
        return (
          <Tooltip placement="leftTop" title={text}>
            {text}
          </Tooltip>
        )
      },
    },
  ]
  const [batchId, setBatchId] = useState('')
  const batchDels = async (id) => {
    await dispatch(
      batchDel({
        co_user_id__in: id,
      })
    )
    message.success('批量删除成功')
    paramsRef.current.page = 1
    await dispatch(getUserList())
    setBatchUserDel(false)
    onReset()
  }
  // 多选框
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setBatchId(`${selectedRowKeys}`)
    },
  }

  // 获取所有用户列表数据
  useEffect(() => {
    if (userInfo?.co_type_code === 'ADMIN_GROUP') {
      dispatch(getUserList())
    } else {
      dispatch(
        getUserList({
          co_id: getCompany(),
        })
      )
      const getOrgList = async () => {
        const res = await dispatch(
          getOrgTreeList(
            {
              co_id: getCompany(),
              is_page: true,
            },
            false
          )
        )
        setOrgData(res)
      }
      getOrgList()
    }
  }, [dispatch])

  // 数据回显
  useEffect(() => {
    const values = {
      ...userInfos,
      ...userInfos.user,
    }
    setTimeout(() => {
      userForm.current?.setFieldsValue({
        ...values,
        co_id: userInfos.co_id ? userInfos.co_id : userCoId ? userCoId : null,
        charge_orgs_name: values.charge_orgs,
        orgs_name: values.orgs,
      })
    }, 0)
  }, [userInfos, userCoId])

  // 点击新增用户弹出框
  const showAddVisible = () => {
    dispatch(
      getPermissionLists({
        co_id: userCoId ? userCoId : getCompany(),
        is_page: true,
      })
    )
    setUserInfos({})
    setTargetKeys([])
    setVisible(true)
  }
  const [watchTableData, setWatchTableData] = useState()
  const showEdit = (users) => {
    dispatch(
      getPermissionLists({
        co_id: users.co_id,
        is_page: true,
      })
    )
    dispatch(
      getOrgTreeList({
        co_id: users.co_id,
        is_page: true,
      })
    )
    users = JSON.parse(JSON.stringify(users))
    setUserInfos(users)
    const { user, ...rest } = { ...users }
    setUser(user)
    setTargetKeys(user.roles)
    setVisible(true)
  }

  // 查询用户
  const userParamsRef = useRef({
    page: 1,
    // page_size: 10,
  })
  const seachUser = async (values) => {
    setUserCoId(values.co_id)
    setCompId(values.co_id)
    userParamsRef.current.co_id = values.co_id
    userParamsRef.current.status_code = values.status_code
    userParamsRef.current.org_id = orgIds ? orgIds : null
    userParamsRef.current.fuzzy_name = values.fuzzy_name
    userParamsRef.current.charge_org_id = chargeOrgId ? chargeOrgId : null
    userParamsRef.current.page = 1
    paramsRef.current.page = 1
    await dispatch(getUserList(userParamsRef.current))
  }

  // 查看用户
  const watchUserInfo = async ({ co_user_id, user, roles }) => {
    setUser(user)
    const rolesData = Array.isArray(user.roles_name)
      ? user.roles_name.map((name) => ({
          name,
          type: '按用户赋权',
        }))
      : []

    const orgRolesData = Array.isArray(user.org_role_names)
      ? user.org_role_names.map((name) => ({
          name,
          type: '按部门赋权',
        }))
      : []
    const tableData = [...rolesData, ...orgRolesData]
    await setWatchTableData(tableData)

    setWatchUser(true)
    const res = await dispatch(getUserInfo(co_user_id))
  }
  // 新增用户
  const onFinish = async (values) => {
    const charges = values.charge_orgs_name
    const orgs = values.orgs_name
    delete values.charge_orgs_name
    if (userInfos.co_user_id) {
      const res = await dispatch(
        editUser({
          ...values,
          user: {
            id: user.id,
            mobile_no: values.mobile_no,
            username: values.username,
            email: values.email,
            orgs: orgs ? (Array.isArray(orgs) ? orgs : [orgs]) : [],
            roles: values.roles,
            charges: charges ? charges : [],
          },
          emp_id: userInfos.co_user_id,
        })
      )
      if (res?.data?.code === 0) {
        message.success('修改用户成功')
        setVisible(false)
        paramsRef.current.page = 1
        await dispatch(
          getUserList({
            ...userParamsRef.current,
            co_id: userCoId ? userCoId : null,
          })
        )
      } else {
        message.error(res?.data?.msg)
      }
    } else {
      const res = await dispatch(
        addUser({
          ...values,
          user: {
            id: values.id,
            mobile_no: values.mobile_no,
            username: values.username,
            email: values.email,
            orgs: !orgId ? [] : [orgId],
            roles: batchAdd || [],
            charges: charges ? charges : [],
          },
        })
      )
      if (res?.data?.code === 0) {
        message.success('新增用户成功')
        setOrgId('')
        SetBatchAdd('')
        setTargetKeys('')
        setVisible(false)
        paramsRef.current.page = 1
        await dispatch(
          getUserList({
            ...userParamsRef.current,
            co_id: userCoId ? userCoId : null,
          })
        )
      } else {
        message.error(res?.data?.msg)
      }
    }
    setChargeOrgId('')
    setOrgIds('')
  }

  const showDel = ({ user, ...rest }) => {
    setUserInfos(rest)
    setUser(user)
    SetDelModal(true)
  }

  // 删除用户
  const delUser = async (id) => {
    await dispatch(delUsers(id))
    message.success('删除用户成功')
    paramsRef.current.page = 1
    await dispatch(getUserList(userParamsRef.current))
    SetDelModal(false)
  }

  // 分页处理
  const onChange = (page, pageSize) => {
    paramsRef.current.co_id = compUser
    paramsRef.current.page = page.current
    paramsRef.current.page_size = page.pageSize
    userParamsRef.current.page_size = page.pageSize
    dispatch(getUserList({ ...userParamsRef.current, ...paramsRef.current }))
  }

  const changeOrg = (value, node) => {
    setOrgId(node.org_id)
    setOrgIds(node.org_id)
  }

  const chargeOrg = (value, node) => {
    setChargeOrgId(node.org_id)
  }
  const paginations = {
    defaultCurrent: 1,
    defaultPageSize: 10,
    current: paramsRef.current.page,
    total: total,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total) => (
      <div>
        {localStorage.getItem('charge_org') === 'true' && (
          <span className="table_note">
            <span style={{ color: '#fc5061' }}>*</span>
            表示人工维护过该用户的分管部门，不会执行自动同步，如需恢复自动同步，则点击"恢复同步"操作
          </span>
        )}
        <span>共{total}条</span>
      </div>
    ),
  }
  const filterOption = (inputValue, option) =>
    option.description.indexOf(inputValue) > -1

  const [compUser, setCompUser] = useState('')
  const changeComps = async (i, o) => {
    await dispatch(
      getUserStatus({ co_id: i, dic_code: 'SYS_CO_USER_STATUS' }, false)
    )
    setCompUser(i)
    const res = await dispatch(
      getOrgTreeList(
        {
          co_id: i,
          is_page: true,
        },
        false
      )
    )
    form.resetFields(['org_id'])
    setOrgIds('')
    setChargeOrgId('')
    setOrgData(JSON.parse(JSON.stringify(res)))
  }
  const changeComp = (i, o) => {
    setCompId(i)
    dispatch(
      getPermissionLists(
        {
          co_id: i,
          is_page: true,
        },
        false
      )
    )
    dispatch(
      getOrgTreeList(
        {
          co_id: i,
          is_page: true,
        },
        false
      )
    )
  }

  const showReset = ({ user }) => {
    setResetModal(true)
    setUser(user)
  }

  const resetUserPassword = async (id) => {
    await dispatch(
      resetPassword({
        user: id,
      })
    )
    message.success('重置密码成功')
    setResetModal(false)
  }

  const [form] = Form.useForm()
  const onReset = () => {
    form.resetFields()
    setCompUser('')
    setOrgIds('')
    setChargeOrgId('')
    if (userInfo?.co_type_code === 'ADMIN_GROUP') {
      setOrgData([])
    }
    setUserCoId('')
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const resetUserLogin = (user) => {
    setUserInfos(user)
    setResetLoginVisible(true)
  }

  const resetUserLoginFn = async (info) => {
    let params = {}
    paramsRef.current.page = 1
    params.co_id = info.co_id
    if (info.status_code === 'ENABLE') {
      params.status_code = 'DISABLE'
    } else {
      params.status_code = 'ENABLE'
    }
    const res = await dispatch(changeUserStatus(info.co_user_id, params))
    if (res.data.code === 0) {
      await dispatch(getUserList(userParamsRef.current))
      setResetLoginVisible(false)
      if (info.status_code === 'ENABLE') {
        message.success('禁用成功')
      } else {
        message.success('启用成功')
      }
    } else {
      message.error(res.data.msg)
    }
  }

  return (
    <div className={styles.root}>
      <ConfigProvider locale={zhCH}>
        <div className="right_content">
          <Breadcrumb>
            <Breadcrumb.Item>系统管理</Breadcrumb.Item>
            <Breadcrumb.Item>用户管理</Breadcrumb.Item>
          </Breadcrumb>
          <Card className="search-card">
            <Form
              style={{ display: 'flex', flexWrap: 'wrap' }}
              colon={false}
              autoComplete="off"
              form={form}
              validateTrigger={['onBlur', 'onChange']}
              className="form-search"
              onFinish={seachUser}
            >
              <div className="flex">
                {userInfo?.co_type_code === 'ADMIN_GROUP' ? (
                  <Form.Item label="企业/产品" name="co_id">
                    <Select
                      onChange={changeComps}
                      filterOption={(input, option) => {
                        const children =
                          option?.children?.props?.children?.[0]?.props
                            ?.children?.props?.children
                        return (
                          children.toLowerCase().indexOf(input.toLowerCase()) >=
                          0
                        )
                      }}
                      showSearch
                      placeholder="请选择企业/产品"
                      style={{ width: 220 }}
                    >
                      {compListForNameCode.map((item) => (
                        <Select.Option value={item.co_id} key={item.co_id}>
                          <div className="myOption">
                            <span className="OptionLeft">
                              <Tooltip title={item.co_name} placement="bottom">
                                {item.co_name}
                              </Tooltip>
                            </span>
                            <span className="OptionRight">{item.co_code}</span>
                          </div>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  ''
                )}

                <Form.Item label="归属部门" name="org_id">
                  <TreeSelect
                    onSelect={changeOrg}
                    treeDefaultExpandAll
                    key="org_id"
                    style={{ width: 160 }}
                    dropdownStyle={{
                      maxHeight: 400,
                      overflow: 'auto',
                      minWidth: 300,
                    }}
                    treeData={orgData}
                    placeholder="请选择部门"
                    showSearch
                    filterTreeNode={(value,node)=>{
                      return node.title?.includes(value)
                    }}
                  ></TreeSelect>
                </Form.Item>
                {localStorage.getItem('charge_org') === 'true' && (
                  <Form.Item label="分管部门" name="charge_org_id">
                    <TreeSelect
                      onSelect={chargeOrg}
                      treeDefaultExpandAll
                      key="charge_org_id"
                      style={{ width: 160 }}
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: 'auto',
                        minWidth: 300,
                      }}
                      treeData={orgData}
                      placeholder="请选择部门"
                      showSearch
                      filterTreeNode={(value,node)=>{
                        return node.title?.includes(value)
                      }}
                    ></TreeSelect>
                  </Form.Item>
                )}

                <Form.Item label="状态" name="status_code">
                  <Select
                    // onChange={changeStatus}
                    showSearch
                    placeholder="请选择状态"
                    style={{ width: 160 }}
                  >
                    {statusList.map((item) => (
                      <Select.Option
                        value={item.dic_item_code}
                        key={item.dic_item_code}
                      >
                        {item.dic_item_name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label="用户名/手机号" name="fuzzy_name">
                  <Input
                    placeholder="请输入用户名或手机号"
                    style={{ width: 160 }}
                  ></Input>
                </Form.Item>
              </div>
              <Form.Item>
                <Space size={[24]}>
                  <MyButton type="default" htmlType="submit">
                    查询
                  </MyButton>
                  <MyButton onClick={onReset}>重置</MyButton>
                </Space>
              </Form.Item>
            </Form>
          </Card>
          <Space size={[24]} className="space-heigth">
            <MyButton type="default" onClick={showAddVisible}>
              + 新增用户
            </MyButton>
            <MyButton
              type="default"
              onClick={() => {
                if (!batchId) return message.error('请至少勾选一条数据')
                setBatchUserDel(true)
              }}
            >
              批量删除
            </MyButton>
          </Space>
          <div className="right_table" ref={tableRef}>
            <Table
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    setSelectedRowKey(record?.co_user_id)
                  }, // 点击行
                }
              }}
              rowClassName={getRowClassName}
              scroll={{ y: size?.height - 95 + 'px' }}
              size="small"
              onChange={onChange}
              rowKey={(i) => {
                return i.co_user_id
              }}
              rowSelection={{
                ...rowSelection,
                getCheckboxProps(value) {
                  return {
                    disabled: value.is_preset,
                  }
                },
              }}
              columns={
                localStorage.getItem('charge_org') === 'true'
                  ? columns
                  : columns.filter((item) => item.title !== '分管部门')
              }
              dataSource={userList}
              pagination={paginations}
            ></Table>
          </div>
        </div>
        {/* 新增用户 */}
        <Drawer
          width={624}
          destroyOnClose={true}
          size="large"
          maskClosable={false}
          title={userInfos.co_user_id ? '修改用户' : '新增用户'}
          placement="right"
          onClose={() => {
            setVisible(false)
          }}
          visible={visible}
        >
          <Form
            colon={false}
            autoComplete="off"
            ref={userForm}
            validateTrigger={['onBlur', 'onChange']}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 18 }}
            onFinish={onFinish}
            onSubmitCapture={(e) => {
              e.preventDefault()
            }}
          >
            <div className="form-btn">
              {userInfo?.co_type_code === 'ADMIN_GROUP' ? (
                <Form.Item
                  label="企业/产品"
                  name="co_id"
                  rules={rulesObj.current.co_id}
                >
                  <Select
                    disabled={userInfos.co_user_id ? true : false}
                    filterOption={(input, option) => {
                      const children =
                        option?.children?.props?.children?.[0]?.props?.children
                          ?.props?.children
                      return (
                        children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      )
                    }}
                    showSearch
                    placeholder="请选择企业/产品"
                    onChange={changeComp}
                  >
                    {compListForNameCode.map((item) => (
                      <Select.Option value={item.co_id} key={item.co_id}>
                        <div className="myOption">
                          <span className="OptionLeft">
                            <Tooltip title={item.co_name} placement="bottom">
                              {item.co_name}
                            </Tooltip>
                          </span>
                          <span className="OptionRight">{item.co_code}</span>
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              ) : (
                ''
              )}
              <div className="flex">
                <Form.Item
                  className="w-50"
                  label="用户名"
                  name="username"
                  rules={rulesObj.current.username}
                >
                  <Input
                    onKeyPress={handleKeyPress}
                    disabled={userInfos.co_user_id ? true : false}
                    maxLength={20}
                    placeholder="请输入用户名"
                  ></Input>
                </Form.Item>
                <Form.Item
                  className="w-50"
                  label="手机号"
                  name="mobile_no"
                  rules={rulesObj.current.mobile_no}
                >
                  <Input
                    onKeyPress={handleKeyPress}
                    maxLength={11}
                    placeholder="请输入手机号"
                  ></Input>
                </Form.Item>
              </div>

              <div className="flex">
                <Form.Item
                  className="w-50"
                  label="姓名"
                  name="full_name"
                  rules={rulesObj.current.full_name}
                >
                  <Input
                    onKeyPress={handleKeyPress}
                    maxLength={20}
                    placeholder="请输入姓名"
                  ></Input>
                </Form.Item>
                <Form.Item
                  className="w-50"
                  label="昵称"
                  name="nickname"
                  rules={rulesObj.current.nickname}
                >
                  <Input
                    onKeyPress={handleKeyPress}
                    maxLength={20}
                    placeholder="请输入昵称"
                  ></Input>
                </Form.Item>
              </div>

              <div className="flex">
                <Form.Item
                  className="w-50"
                  label="邮箱"
                  name="email"
                  rules={rulesObj.current.email}
                >
                  <Input
                    onKeyPress={handleKeyPress}
                    maxLength={50}
                    placeholder="请输入邮箱"
                  ></Input>
                </Form.Item>
                <Form.Item
                  rules={rulesObj.current.employee_no}
                  className="w-50"
                  label="工号"
                  name="employee_no"
                >
                  <Input
                    onKeyPress={handleKeyPress}
                    maxLength={20}
                    placeholder="不超过20个字"
                  ></Input>
                </Form.Item>
              </div>
              <div className="flex">
                <Form.Item className="w-50" label="归属部门" name="orgs_name">
                  <TreeSelect
                    allowClear={true}
                    treeDefaultExpandAll
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    treeData={orgTreeListCope}
                    placeholder="请选择部门名称"
                    onSelect={changeOrg}
                    fieldNames={{
                      title: 'org_name',
                      value: 'org_id',
                      key: 'org_id',
                    }}
                  ></TreeSelect>
                </Form.Item>
                <Form.Item
                  className="w-50"
                  label="分管部门"
                  name="charge_orgs_name"
                >
                  <TreeSelect
                    maxTagCount={1}
                    multiple
                    allowClear={true}
                    treeDefaultExpandAll
                    dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                    treeData={orgTreeListCope}
                    placeholder="请选择部门名称"
                    onSelect={chargeOrg}
                    fieldNames={{
                      title: 'org_name',
                      value: 'org_id',
                      key: 'org_id',
                    }}
                  ></TreeSelect>
                </Form.Item>
              </div>

              <Form.Item label="所属角色" name="roles">
                <Transfer
                  showSelectAll={false}
                  titles={['未选角色', '已选角色']}
                  filterOption={filterOption}
                  dataSource={
                    userInfo?.co_type_code !== 'ADMIN_GROUP'
                      ? userInfo?.is_creator
                        ? permissionListAll
                        : permissionListAll?.filter(
                            (i) => i.role_code !== 'CREATOR'
                          )
                      : permissionListAll
                  }
                  targetKeys={targetKeys}
                  onChange={handleChange}
                  render={(item) => {
                    return item.title
                  }}
                />
              </Form.Item>
            </div>
            <Form.Item>
              <div className="flex_end">
                <Space>
                  <MyButton onClick={() => setVisible(false)}>取消</MyButton>
                  <MyButton type="default" htmlType="submit">
                    {userInfos.co_user_id ? '修改' : '新增'}
                  </MyButton>
                </Space>
              </div>
            </Form.Item>
          </Form>
        </Drawer>
        {/* 批量删除用户对话框 */}
        <Modal
          bodyStyle={{ textAlign: 'center' }}
          centered
          onCancel={() => setBatchUserDel(false)}
          title="批量删除用户"
          visible={batchUserDel}
          getContainer={false}
          okText="删除"
          footer={[
            <Space size={[24]} className="model-btn">
              <MyButton onClick={() => setBatchUserDel(false)}>取消</MyButton>
              <MyButton type="default" onClick={() => batchDels(batchId)}>
                删除
              </MyButton>
            </Space>,
          ]}
        >
          <p>
            <MyIcon
              style={{ fontSize: 40 }}
              type="icon-a-gaojingshixin1"
            ></MyIcon>
          </p>
          <p>删除所选用户后将删除所选用户下所有角色</p>
          <p>确定要删除所选用户吗？</p>
        </Modal>
        {/* 查看用户对话框 */}
        <Drawer
          destroyOnClose={true}
          size="large"
          placement="right"
          title="查看用户"
          onClose={() => {
            setWatchUser(false)
          }}
          visible={watchUser}
        >
          <div className="msg">
            <span className="linear"></span> 基本信息
          </div>
          <div className="watch_marg">
            {userInfo?.co_type_code === 'ADMIN_GROUP' ? (
              <p>
                <span>企业/产品</span>
                {userInfoItem.co_name || '-'}
              </p>
            ) : (
              ''
            )}
            <p>
              <span>用户名</span>
              {user.username || '-'}
            </p>
            <p>
              <span>手机号</span>
              {user.mobile_no || '-'}
            </p>
            <p>
              <span>姓名</span>
              {userInfoItem.full_name || '-'}
            </p>
            <p>
              <span>昵称</span>
              {userInfoItem.nickname || '-'}
            </p>
            <p>
              <span>邮箱</span>
              {userInfoItem.email || '-'}
            </p>
            <p>
              <span>工号</span>
              {userInfoItem.employee_no || '-'}
            </p>
            <p>
              <span>归属部门</span>
              {user.org_name || '-'}
            </p>
            <p>
              <span>分管部门</span>
              {user.charge_org_name || '-'}
            </p>
            <p>
              <span>所属角色</span>
            </p>
          </div>

          <Table
            className="watch-table"
            size="small"
            columns={watchCol}
            dataSource={watchTableData}
          ></Table>
        </Drawer>
        {/* 删除用户 */}
        <Modal
          bodyStyle={{ textAlign: 'center' }}
          centered
          onCancel={() => SetDelModal(false)}
          title="删除用户"
          visible={delModal}
          getContainer={false}
          okText="删除"
          cancelText="取消"
          footer={[
            <Space size={[24]} className="model-btn">
              <MyButton onClick={() => SetDelModal(false)}>取消</MyButton>
              <MyButton
                type="default"
                onClick={() => delUser(userInfos.co_user_id)}
              >
                删除
              </MyButton>
            </Space>,
          ]}
        >
          <p>
            <MyIcon
              style={{ fontSize: 40 }}
              type="icon-a-gaojingshixin1"
            ></MyIcon>
          </p>
          <p>确定要删除用户"{user.username}"吗？</p>
        </Modal>
        {/* 重置密码 */}
        <Modal
          bodyStyle={{ textAlign: 'center' }}
          centered
          onCancel={() => setResetModal(false)}
          title="重置密码"
          visible={resetModal}
          getContainer={false}
          footer={[
            <Space size={[24]} className="model-btn">
              <MyButton onClick={() => setResetModal(false)}>取消</MyButton>
              <MyButton
                type="default"
                onClick={() => resetUserPassword(user.id)}
              >
                重置
              </MyButton>
            </Space>,
          ]}
        >
          <p>确定要重置用户“{user.username}”的密码吗？</p>
        </Modal>
        {/* 恢复同步 */}
        <Modal
          bodyStyle={{ textAlign: 'center' }}
          centered
          onCancel={() => setResetChangeModal(false)}
          title="恢复同步"
          visible={resetChangeModal}
          getContainer={false}
          footer={[
            <Space size={[24]} className="model-btn">
              <MyButton onClick={() => setResetChangeModal(false)}>
                取消
              </MyButton>
              <MyButton type="default" onClick={() => resetChange(userInfos)}>
                确定
              </MyButton>
            </Space>,
          ]}
        >
          <p style={{ fontSize: '18px' }}>确定要恢复同步吗？</p>
          <p>恢复同步后该用户将定期从OA系统获取分管部门信息</p>
        </Modal>
        {/* 启用/禁用 */}
        <Modal
          bodyStyle={{ textAlign: 'center' }}
          centered
          onCancel={() => setResetLoginVisible(false)}
          title={userInfos.status_code === 'ENABLE' ? '禁用' : '启用'}
          visible={resetLoginVisible}
          getContainer={false}
          footer={[
            <Space size={[24]} className="model-btn">
              <MyButton onClick={() => setResetLoginVisible(false)}>
                取消
              </MyButton>
              <MyButton
                type="default"
                onClick={() => resetUserLoginFn(userInfos)}
              >
                确定
              </MyButton>
            </Space>,
          ]}
        >
          <p style={{ fontSize: '18px' }}>
            确定要{userInfos.status_code === 'ENABLE' ? '禁用' : '启用'}
            该用户吗？
          </p>
          {userInfos.status_code === 'ENABLE' && (
            <p>禁用后该用户无法登录系统</p>
          )}
        </Modal>
      </ConfigProvider>
    </div>
  )
}
